import './scripts/common';
import onInitModulesInScope from "./scripts/onInitModulesInScope";

if (!window.HTMLPictureElement) {
    import('picturefill');
}


let _config = window['_config'] || {};

let app = window['app'] || {
    debug: false,
};

window.app = app || {};
window.app.modules =  app.modules || {};

import initModulesInScope from "@elements/init-modules-in-scope";
app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('./scripts/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as checkoutCountry from './scripts/checkout-country';
onInitModulesInScope(checkoutCountry.initInScope);

import * as cartDetail from './scripts/cart-detail';
cartDetail.init();

import * as discountItem from './scripts/discount-item';
onInitModulesInScope(discountItem.initInScope);

import * as reloadForm from '@elements/reload-form';
onInitModulesInScope(reloadForm.initInScope);

import * as addFormSection from './scripts/add-form-section';
addFormSection.init();

import * as formWithOverlay from './scripts/form-with-overlay';
onInitModulesInScope(formWithOverlay.initInScope);

import * as checkAddress from './scripts/check-address';
onInitModulesInScope(checkAddress.initInScope);

import * as waitForPayment from "./scripts/waitForPayment";
waitForPayment.init();

import * as molliePayment  from './scripts/mollie-payment';
molliePayment.init();

import * as applePay from "./scripts/apple-pay";
onInitModulesInScope(applePay.initInScope);

import * as dateInput from './scripts/date-input';
onInitModulesInScope(dateInput.initInScope);

import * as paymentForm from './scripts/parsley-custom';
onInitModulesInScope(paymentForm.initInScope);

import * as removeVoucher from './scripts/remove-voucher';
onInitModulesInScope(removeVoucher.initInScope);

const $modalVoucher = $(document).find('#modalVoucher');
const $modalVoucherMobile= $(document).find('#modalVoucherMobile');
// Check for desktop
if (window.matchMedia('(min-width: 768px)').matches) {
    if ($modalVoucher.length > 0) {
        console.log('modalVoucher', $modalVoucher);
        $modalVoucher.modal('show');
    }
}

// Check for mobile
if (window.matchMedia('(max-width: 767px)').matches) {
    if ($modalVoucherMobile.length > 0) {
        $modalVoucherMobile.modal('show');
    }
}

// check if user reached bottom
$(window).scroll(function() {
    if($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
        $('body').addClass('is-bottom');
    }else{
        if($('body').hasClass('is-bottom')){
            $('body').removeClass('is-bottom');
        }
    }
});

(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    initModulesInScope();
})(jQuery);
